import React, { useState, useEffect } from "react";
import {
  Button,
  Carousel,
  Container,
  FormControl,
  InputGroup,
  Modal,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { SliderImages } from "../../../asset/json/CardDetail";
import "../../../styles/solution.scss";
import { MenuButton, TitleButton } from "../../common/Buttons";
import Background from "../../../asset/image/backgroundImage.svg";
import { Helmet } from "react-helmet";
import { HashLink as Link } from "react-router-hash-link";
import CloudSocial from "../../../asset/image/CloudSocialLogo.svg";
import { AllSocialMedia } from "../solutions/AllMedia";
import {
  CardDetails1,
  CardDetails2,
  CardDetails3,
} from "../solutions/CardComponent";
import { Media } from "../solutions/Media";
// import NavBar from "../../common/NavBar";
import Rectangle1 from "../../../asset/image/Rectangle1.png";
import Rectangle2 from "../../../asset/image/Rectangle2.png";
import dots from "../../../asset/image/dots.png";

const Home1 = (props) => {
  var location = props.location.pathname;
  const [show, setShow] = useState(false);
  const [video, setVideo] = useState("");
  const handleClose = () => setShow(false);
  const [searchInput, setSearchInput] = useState("");

  const handleShow = () => {
    setShow(true);
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);
  const handleChange = (e) => {
    e.preventDefault();
  };
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" name="CloudSocial Solution page" />

        {location === "/" ? (
          <title>Social Media Management Tools - CloudSocial</title>
        ) : (
          <title>Social Media Marketing Automation Tools | CloudSocial</title>
        )}
        {location === "/" ? (
          <meta
            name="description"
            content="Best social media management tools built to manage all your social media handles at one place. Grow and engage with an ease of social media listening."
          />
        ) : (
          <meta
            name="description"
            content="CloudSocial's solution effortlessly help you to manage your multiple social media channels from social media post scheduling, reporting, social listening and much more."
          />
        )}
        <link rel="canonical" href="https://cloudsocial.io" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content=" days" />
        <meta name="author" content="" />
      </Helmet>
      {/* <Container style={{ height: "100%", width: "100%" }}>
        <h1 className="heading mt-1" onClick={handleShow}>
          CloudSocial
        </h1>
        <h6 className="sub-heading" onClick={handleShow}>
          A Complete Social Media Management Tool
        </h6>
        <div className="link-btn">
          <LinkContainer to="">
            <TitleButton />
          </LinkContainer>
          <MenuButton />
        </div>
      </Container> */}
      <div className="bubble1" />
      <div className="bubble2" />
      <div className="bubble3" />

      <div style={{ height: "100%", width: "100%" }}>
        {/* {location === "/home1" && ( */}
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "flex-end",
            }}
          >
            <img
              alt=""
              src={Rectangle1}
              style={{
                height: "70%",
                marginTop: "-10px",
                marginLeft: "1rem",
              }}
              className="Homegirlimg"
            />
          </div>
          <div style={{ marginTop: "5rem" }}>
            <div>
              <h1 className="heading mt-1">Your IG Tools Alternative</h1>
              <h6 className="sub-heading" style={{ textAlign: "left" }}>
                CloudSocial is the new Instagram automation tool that you’ve
                been waiting for. It’s the perfect alternative to IG Tools, and
                it offers all of the same features, plus a whole lot more. With
                CloudSocial, you can manage your account with ease and get more
                followers than ever before.
              </h6>
            </div>
            <div className="getstartblock">
              <Button
                className="getStart"
                href="https://app.cloudsocial.io/accounts/gold/9"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Started
              </Button>
            </div>
            <div className="dots">
              <img alt="dots" src={dots} />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <img
              alt=""
              src={Rectangle2}
              style={{ height: "65%", marginLeft: "2rem" }}
              className="Homechildimg"
            />
          </div>
        </div>
        {/* )} */}
      </div>
      <Media />

      <div
        style={{
          background: "#F5FBFF ",
          //  border: "none",
          backgroundImage: `url(${Background})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <CardDetails1 />
        <CardDetails2 />
        <CardDetails3 />
      </div>

      <AllSocialMedia />
      {/* <div style={{ display: "none" }}>
        <Link to="/resources">Resources</Link>
      </div> */}
    </div>
  );
};

export default Home1;
